<template>
  <div class="hot">
    <div class="title">热门推荐</div>
    <div
      class="item"
      v-for="item of hotList"
      :key="item.id"
      @click="goDetail(item.id)"
    >
      <div class="item-left">
        <img :src="item.image" alt="" />
      </div>
      <div class="item-right">
        <div class="name">{{ item.store_name }}</div>
        <div class="price">￥{{ item.price }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getProductHot } from "@api/store";
export default {
  name: "HotRecommendation",
  data() {
    return {
      hotList: []
    };
  },
  created() {
    getProductHot().then(res => {
      this.hotList = res.data;
    });
  },
  methods: {
    goDetail(id) {
      this.$router.push("/goodsDetail/" + id);
    }
  }
};
</script>

<style lang="stylus" scoped>
.hot
  border 1px solid #e4e4e4
  font-family '宋体'
  .title
    height 40px
    line-height 40px
    background #f4f7f7
    font-size 15px
    padding-left: 10px;
    color #555555
    font-weight bold
  .item
    cursor pointer
    padding 20px 10px
    display flex
    border-bottom 1px dashed #ccc
    &:last-child
      border-bottom 0
    &-left
      width 70px
      height 70px
      margin-right 20px
      img
        width 100%
        height 100%
    &-right
      font-family '宋体'
      width 140px
      .name
        font-size 14px
        margin-bottom 15px
        display -webkit-box !important
        overflow hidden
        text-overflow ellipsis
        word-break break-all
        -webkit-box-orient vertical
        -webkit-line-clamp 2
      .price
        flex 1
        font-size 16px
        color #ff5c4d
        font-weight bold
</style>
